const initialState = {
  isError: false,
  message: '',
  isLoading: false,
};

export default initialState;
